import script from "./ReactionAddButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ReactionAddButton.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__